import React, { useRef } from 'react';
var VeltAutocompleteOptionDescription = function (props) {
    var field = props.field, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-description", { ref: ref, field: field }, children));
};
export default VeltAutocompleteOptionDescription;
